<template>
      <div class="conf-con">
                            <div class="intro-pic">
                              <img src="../../../assets/images/05.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第五次全国代表大会简介</p>
                            <p class="margin1">1927年蒋介石发动四一二反革命政变，大肆屠杀共产党人和革命群众，大革命遭到了局部的严重失败。此后，全国形成了三个政权，即原来的北洋军阀政府，上海、南京的蒋介石反革命政权和武汉国民政府。面对错综复杂的矛盾和尖锐激烈的斗争，需要中国共产党对形势有清醒的认识并采取果断行动，才能挽救革命。党的五大就是在这种非常状态下召开的。全体党员期望这次大会能正确判断当前局势，回答大家最为关注的如何从危急中挽救革命的问题。</p>
                            <p class="margin1">1927年4月27日至5月9日，中国共产党第五次全国代表大会在武汉召开。出席大会的代表有：陈独秀、蔡和森、瞿秋白、毛泽东、任弼时、刘少奇、邓中夏、张国焘、张太雷、李立三、李维汉、陈延年、彭湃、方志敏、恽代英、罗亦农、项英、董必武、陈潭秋、苏兆征、向警予、蔡畅、向忠发、罗章龙、贺昌、阮啸仙、王荷波、彭述之等82人，代表着57967名党员。共产国际代表罗易、鲍罗廷、维经斯基等出席了大会。</p>
                            <p class="margin1">陈独秀代表第四届中央执行委员会向大会作了《政治与组织的报告》，涉及中国各阶级、土地、无产阶级领导权、军事、国共两党关系等11个问题。报告既没有正确总结经验教训，又没有提出挽救时局的方针政策，反而为过去的错误进行辩护，继续提出一些错误主张。</p>
                            <p class="margin1">共产国际代表团团长罗易作了题为《中国革命问题和无产阶级的作用》的讲话。代表们对陈独秀的错误进行了批评。会前，瞿秋白针对陈独秀、彭述之等的机会主义理论和政策，写成了《中国革命中之争论问题》一书，着重论述了无产阶级和资产阶级争夺领导权问题。会上他把该书发给大家，并作了系统发言。针对陈独秀报告关于统一战线上的错误，蔡和森在发言中指出：中国小资产阶级政党（国民党）过去之弱点及现在动摇，说明能领导革命到底并取得胜利的只有无产阶级政党。我们应以坚决的无产阶级的领导去制胜小资产阶级的动摇与犹疑。毛泽东批评了陈独秀在对待农民问题上的错误，主张把农民组织和武装起来，迅速加强农民的斗争。</p>
                            <p class="margin1">大会通过了《政治形势与党的任务议决案》《土地问题议决案》等，选出了由31名正式委员和14名候补委员组成的党的中央委员会。随后举行的五届一中全会选举陈独秀、蔡和森、李维汉、瞿秋白、张国焘、谭平山、李立三、周恩来为中央政治局委员，苏兆征、张太雷等为候补委员；选举陈独秀、张国焘、蔡和森为中央政治局常务委员会委员，陈独秀为总书记。大会第一次选举产生了中央监察委员会，由正式委员7人、候补委员3人组成。</p>
                            <p class="margin1">党的五大虽然批评了陈独秀的错误，但对无产阶级如何争取领导权，如何领导农民进行土地革命，如何对待武汉国民政府和国民党，特别是如何建立党的革命武装等迫在眉睫的重大问题，都未能作出切实可行的回答，因此，难以承担在生死存亡的危急关头挽救大革命的重任。而真正结束中央所犯的右倾机会主义错误，制定正确的土地革命和武装起义方针，是在3个月后的八七会议上完成的。</p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>